<template>
  <div class="controllerJianhuyi">
    <div class="controller-modules-header left">有创导管</div>
    <div class="radio-controller">
      <div
        class="item"
        v-for="(item, index) in youchuangList"
        :key="index"
        :class="daoguan == item.type ? 'item-active' : ''"
        @click="handlerRadio('daoguan', item.type)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="controller-modules-header left">监护仪显示</div>
    <div class="radio-controller">
      <div
        class="item"
        v-for="(item, index) in jianhuyiLise"
        :key="index"
        :class="xianshi == item.type ? 'item-active' : ''"
        @click="handlerRadio('xianshi', item.type)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="controller-modules-header left">神经刺激器</div>
    <div class="radio-controller">
      <div
        class="item"
        v-for="(item, index) in shenjingList"
        :key="index"
        :class="cijiqi == item.type ? 'item-active' : ''"
        @click="handlerRadio('cijiqi', item.type)"
      >
        {{ item.name }}
      </div>
    </div>

    <div class="controller-modules-header left">操作记录</div>
    <div class="controller-modules-log">
      <block v-show="actionLog.length != 0">
        <div class="item" v-for="(item, index) in actionLog" :key="index">
        【{{formateSeconds(item.logTime)}}】{{item.logContent}}
        </div>
      </block>
      <block v-show="actionLog.length == 0">
        <div class="item" >
            暂无操作记录。
        </div>
      </block>
    </div>
  </div>
</template>
<script>
import {youchuangList,jianhuyiLise,shenjingList} from '@/utils/data'
import { mapGetters, mapActions } from "vuex";
import  {formateSeconds} from '@/utils/tool'
export default {
  data() {
    return {
      youchuangList,
      jianhuyiLise,
      shenjingList,
      daoguan: "",
      xianshi: "",
      cijiqi: "",
      formateSeconds,
      actionLog:[],
    };
  },
  created(){
    this.getActionLog();
  },
  methods: { 
    ...mapActions({
      submitStep:"exma/submitStep",
      setJianhuyi:"controller/setJianhuyi",
      nbpRun:"controller/nbpRun",
    }),
    handlerRadio(model, type) {
      this[model] = type || "";
      //nbp不算是步骤
      if(type == 'measure_nbp'){
        this.setJianhuyi(type);
        this.nbpRun();
        return;
      }
      let d = {
        memberCaseId:this.memberCaseId,
        component:type,
        actionTime:this.getHandleTimeAt,
      };
      this.submitStep(d).then(res=>{
        if(res == 1 && model == 'xianshi'){
          this.setJianhuyi(type);
        }
        this.getActionLog();
      })
    },
    async getActionLog(){
      try{
        let res = await this.$http.post(this.$interface.examActionLog,{
          componentCategory:'monitors',
          memberCaseId:this.memberCaseId,
        })
        this.actionLog = res.data.data || [];
        console.log(res);
      }catch(err){}
    }
  },
  computed: {
    ...mapGetters(["getHandleTimeAt",'memberCaseId']),
  },
};
</script>
<style lang="scss">
@import "../index.scss";
</style>